<template>
  <VideosTab
    :product="NEW_TECHNOLOGY.slug"
    :categories-videos="NEW_TECHNOLOGY_CATEGORIES"
    @toggle-view-more="toggleViewMore"
    @play-video="$emit('play-video', $event)"
  />
</template>

<script lang="ts" setup>
import VideosTab from '~/components/market-insights/VideosTab.vue'
import {
  NEW_TECHNOLOGY,
  SILICON_ANODE,
  SODIUM_ION_BATTERIES,
  SOLID_STATE,
} from '~/constants/services/constants'
import type { TMarketSlug } from '~/src/types/markets'

definePageMeta({ isTab: true, layout: 'services' })

const NEW_TECHNOLOGY_CATEGORIES: TMarketSlug[] = [
  SILICON_ANODE.slug,
  SODIUM_ION_BATTERIES.slug,
  SOLID_STATE.slug,
  NEW_TECHNOLOGY.slug,
]
const isViewMoreActive = useState<boolean>('isViewMoreActive', () => false)

const toggleViewMore = (isActive: boolean) => {
  isViewMoreActive.value = isActive
}

onUnmounted(() => {
  isViewMoreActive.value = false
})

defineEmits<{
  'play-video': [value: string]
}>()
</script>
